<div class="container container_type_main">
  <div class="page-error">
    <div class="page-error__content">
      <div class="page-error__title">{{ '500-page.title' | translate }}</div>
      <div class="page-error__subtitle">{{ '500-page.text' | translate }}</div>
      <div class="page-error__button">
        <span (click)="back()" class="button">{{ '500-page.reload' | translate }}</span>
      </div>
    </div>
    <div class="page-error__img">
      <img src="img/cats/interference.png" [alt]="'500-page.title' | translate">
    </div>
  </div>
</div>
